module.exports = __webpack_public_path__ + "4f20c2ebd817aa35440125fcb4e6e796.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Avdelare/img/soffa_mob_gray.gif
 ** module id = 460
 ** module chunks = 0
 **/